import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import { RecordRTCPromisesHandler } from 'recordrtc';
import { useSpeechSynthesis } from 'react-speech-kit';
import {
  createInterviewVideoBlob,
  storeTimeStampApi,
} from '../api/saveVideoBlob';
import axios from 'axios';
import { BASE_URL } from '../utils/config';
import { useVideoChunkUploader } from '../hooks/useVideoChunkUploader';

const MainContext = createContext<any>(null);

let intervalId: any;

type Props = {
  children: any;
};

export const InterviewProvider = ({ children }: Props) => {
  const [recorder, setRecorder] = useState<
    RecordRTCPromisesHandler | null | any
  >();
  const [recorderForEachQuestionRecord, SetRecorderForEachQuestionRecord] =
    useState<RecordRTCPromisesHandler | null>();
  const [stream, setStream] = useState<MediaStream | null>();
  const [finalStream, setFinalStream] = useState<MediaStream | null>();

  const [interviewStatus, setInterviewStatus] = useState<{
    isInterviewStarted: boolean;
    isInterviewFinished: boolean;
  }>({
    isInterviewStarted: false,
    isInterviewFinished: false,
  });

  const [videoBlob, setVideoBlob] = useState<Blob>();

  const [currentQuestion, setCurrentQuestion] = useState<string>();
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState<number>(-1);

  const [noiseArray, setNoiseArray] = useState<number[]>([]);
  const [extendedSilence, setExtendedSilence] = useState<boolean>(false);
  const [extendedSilenceArray, setExtendedSilenceArray] = useState<number[]>(
    []
  );

  const [thumbnailImg, setThumbnailImg] = useState<File>();

  const [showSelfScreen, setShowSelfScreen] = useState<boolean>(true);

  const [isRecordingStarted, setIsRecordingStarted] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [isTimerOn, setIsTimerOn] = useState<boolean>(false);

  const [uploadProgress, setUploadProgress] = useState<number>(0);
  const [audioPlay, setAudioPlay] = useState<Blob>();
  const [isCameraAndMicSettingOpen, setIsCameraAndMicSettingOpen] =
    useState<boolean>(false);
  const [recruiterName, setRecruiterName] = useState<string>();
  const [timerOff, setTimerOff] = useState<boolean>(false);

  const [totalInterviewTime, setTotalInterviewTime] = useState<{
    startTime: Date;
    endTime: Date;
  }>({
    startTime: new Date(),
    endTime: new Date(),
  });

  const [isInitState, setIsInitState] = useState<boolean>(true);
  const [audioDevices, setAudioDevices] = useState<any[]>([]);
  const [currentAudio, setCurrentAudio] = useState<any>();
  const [videoDevices, setVideoDevices] = useState<any[]>([]);
  const [currentVideo, setCurrentVideo] = useState<any>();
  const [isSplitVideo, setIsSplitVideo] = useState<boolean>(false);
  const [blobInterval, setBlobInterval] = useState<any[]>([]);
  const [interviewUploadSuccessfull, setInterviewUploadSuccessfull] =
    useState<boolean>(false);

  const [storeTimeStamp, setStoreTimeStamp] = useState<any>([]);
  const [interviewData, setInterviewData] = useState<any>({
    candidate: {},
    enterprise: {},
    job: {},
  });
  const [onboardingCandidateData, setOnboardingCandidateData] = useState<any>(
    {}
  );
  const [candidateData, setCandidateData] = useState<any>();
  const [enterpriseData, setEnterpriseData] = useState<any>();
  const [candidateLinkId, setCandidateLinkId] = useState<any>(null);
  const [jobData, setJobData] = useState<any>({
    jobTitle: '',
    jobDescription: '',
  });

  const [openPermissionDialog, setOpenPermissionDialog] =
    useState<boolean>(false);
  const [isVideoBackgroundEnabled, setIsVideoBackgroundEnabled] =
    useState<Boolean | null>(false);
  const [videoBackgroundConfig, setVideoBackgroundConfig] = useState({
    isImgBackground: false,
    videoBackgroundColor: '#ffffff',
  });
  const myVideo = useRef<any>();
  const finalVideo = useRef<any>();

  const [isQuestionSpeaking, setIsQuestionSpeaking] = useState<any>(false);
  const { speak, speaking } = useSpeechSynthesis();

  const [questionsText, setQuestionsText] = useState<any[]>([]);

  const [questionsAudio, setQuestionsAudio] = useState<any[]>([]);
  const [tempCurrentVideo, setTempCurrentVideo] = useState<any>();
  const [tempCurrentAudio, setTempCurrentAudio] = useState<any>();
  const [speakingScreen, setSpeakingScreen] = useState<any>(false);
  const [timer, setTimer] = useState<number>(3);
  const [timeState, setTimeState] = useState<any>('');
  const [activeStreams, setActiveStreams] = useState<MediaStream[]>([]);
  const [lastQuestionApiResponse, setLastQuestionApiResponse] =
    useState<boolean>(false);
  
  // Interview completion tracking
  const [totalQuestions, setTotalQuestions] = useState<number>(0);
  const [isLastQuestion, setIsLastQuestion] = useState<boolean>(false);
  const [isFinishButtonPressed, setIsFinishButtonPressed] = useState<boolean>(false);
  const [shouldExecuteFinalFlow, setShouldExecuteFinalFlow] = useState<boolean>(false);
  const [interviewAudioResponse, setInterviewAudioResponse] =
    useState<boolean>(false);
  const [videoArray, setVideoArray] = useState();
  const [synthesiaVideoLinkArray, setSynthesiaVideoLinkArray] = useState<any[]>(
    []
  );
  const [isLoadVideo, setIsLoadVideo] = useState<boolean>(true);
  const [synthesiaVideos, setSynthesiaVideos] = useState<any>({
    engageVideo: 'https://tironemprod.blob.core.windows.net/interviewvideos/952c1d05-0113-4bb2-9298-ed1545e1868e.webm',
    introductionVideo: 'https://tironemprod.blob.core.windows.net/interviewvideos/952c1d05-0113-4bb2-9298-ed1545e1868e.webm',
    closingVideo: 'https://tironemprod.blob.core.windows.net/interviewvideos/38c9f194-555f-48b3-a1c8-fbf7ac21071d.webm',
  });

  const [initialVideoPlay, setInitialVideoPlay] = useState<boolean>(true);
  const [closingVideoPlay, setClosingVideoPlay] = useState<boolean>(false);
  const [openPopup, setOpenPopup] = useState<boolean>(false);
  const [isSynthesiaClosingPlaying, setIsSynthesiaClosingPlaying] =
    useState<boolean>(false);

  const { startChunkUploader, stopChunkUploader } = useVideoChunkUploader(
    interviewData?.candidate?.pk_CampaignLine_ID,
    interviewData?.candidate?.fk_Campaign_ID,
    myVideo.current?.srcObject
  );

  const questionVideoRef = useRef<any>();

  const [isQuestionVideoPlay, setIsQuestionVideoPlay] =
    useState<boolean>(false);

  useEffect(() => {
    if (questionVideoRef?.current) {
      if (!questionVideoRef?.current?.ended) {
        setIsQuestionVideoPlay(true);
      } else {
        setIsQuestionVideoPlay(false);
      }
    }
  }, [questionVideoRef?.current?.paused]);

  useEffect(() => {
    if (questionVideoRef?.current?.ended) {
      startAudioRecorder();
    }
  }, [questionVideoRef?.current?.ended]);

  const startAudioRecorder = async () => {
    const response = await recorderForEachQuestionRecord?.getState();

    if (recorderForEachQuestionRecord && response !== 'inactive') {
      console.log('Recording is already in progress.');
      return;
    }

    try {
      recorderForEachQuestionRecord?.startRecording();
    } catch (error) {
      console.error('Error starting the recorder:', error);
    }
  };

  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  const canvasOutputRef = useRef<any>();

  const canvasCtx: any = canvasOutputRef.current?.getContext('2d');

  const logoutState = () => {
    setInterviewStatus({
      isInterviewStarted: false,
      isInterviewFinished: false,
    });

    setIsInitState(true);
    setInterviewUploadSuccessfull(false);
    setIsVideoBackgroundEnabled(false);
    setCurrentQuestionIndex(-1);
    setCurrentQuestion(undefined);
  };

  useEffect(() => {
    if (interviewAudioResponse && lastQuestionApiResponse) {
      setUploadProgress(100);

      setInterviewUploadSuccessfull(true);
    }
  }, [interviewAudioResponse, lastQuestionApiResponse]);

  // Track when we reach the last question
  useEffect(() => {
    if (totalQuestions > 0 && currentQuestionIndex >= 0) {
      const isLast = currentQuestionIndex === totalQuestions - 1;
      setIsLastQuestion(isLast);
      console.log('Current question index:', currentQuestionIndex, 'Total questions:', totalQuestions, 'Is last question:', isLast);
    }
  }, [currentQuestionIndex, totalQuestions]);

  // Execute final flow when finish button is pressed on last question
  useEffect(() => {
    if (isFinishButtonPressed && isLastQuestion && shouldExecuteFinalFlow) {
      console.log('Executing final flow for last question...');
      executeFinalQuestionFlow();
    }
  }, [isFinishButtonPressed, isLastQuestion, shouldExecuteFinalFlow]);

  // Function to execute final question flow
  const executeFinalQuestionFlow = async () => {
    console.log('=== EXECUTING FINAL QUESTION FLOW ===');
    
    try {
      // Stop chunk uploader
      stopChunkUploader();
      
      // Process all timestamp data
      const storeDataFiltered = [
        ...storeTimeStamp
          .reduce((map: any, obj: any) => map.set(obj.Q_number, obj), new Map())
          .values(),
      ];

      storeDataFiltered.forEach((item: any) => delete item.Q_number);

      console.log('Final question - storeDataFiltered:', storeDataFiltered);
      
      // Call storeTimeStampApi with all timestamp data
      const mappedData = storeDataFiltered.map((item: any) => [item['QuestionID'], item]);
      const uniqueData = Array.from(new Map(mappedData).values());
      
      console.log('Final question - calling storeTimeStampApi with data:', uniqueData);
      const responseTimeStamp = await storeTimeStampApi(uniqueData);
      console.log('Final question - storeTimeStampApi response:', responseTimeStamp);
      
      setLastQuestionApiResponse(true);
      
      // Reset flags
      setIsFinishButtonPressed(false);
      setShouldExecuteFinalFlow(false);
      
      console.log('=== FINAL QUESTION FLOW COMPLETED ===');
      
    } catch (error: any) {
      console.error('Final question flow failed:', error);
      console.error('Error details:', {
        message: error?.message,
        status: error?.response?.status,
        statusText: error?.response?.statusText,
        data: error?.response?.data
      });
      
      // Still set response to true to continue flow
      setLastQuestionApiResponse(true);
      setIsFinishButtonPressed(false);
      setShouldExecuteFinalFlow(false);
    }
  };

  const storeEachQuestionsBlob = async (flag: boolean) => {
    console.log('storeEachQuestionsBlob called with flag:', flag);
    console.log('isQuestionSpeaking:', isQuestionSpeaking);
    console.log('recorderForEachQuestionRecord:', !!recorderForEachQuestionRecord);
    console.log('isLastQuestion:', isLastQuestion);
    console.log('currentQuestionIndex:', currentQuestionIndex);
    console.log('totalQuestions:', totalQuestions);

    // Check if this is the final question and finish button was pressed
    if (flag && isLastQuestion) {
      console.log('Last question with flag=true - setting up final flow execution');
      setIsFinishButtonPressed(true);
      setShouldExecuteFinalFlow(true);
      return; // Let the useEffect handle the final flow
    }

    // Regular question processing
    if (!isQuestionSpeaking && recorderForEachQuestionRecord) {
      await recorderForEachQuestionRecord.stopRecording();

      await recorderForEachQuestionRecord.getBlob();

      const saveVideoFormData = new FormData();

      let videoDataObj = {
        QuestionResponse_QuestionText: currentQuestion,
        fk_CampaignLine_ID: interviewData?.candidate?.pk_CampaignLine_ID,
        fk_Question_ID: questionsText[currentQuestionIndex]?.question_id,
        QuestionResponse_AccessLevel:
          questionsText[currentQuestionIndex]?.Question_AccessLevel,
        QuestionResponse_Status:
          questionsText[currentQuestionIndex]?.Question_Status,
      };

      saveVideoFormData.append(
        'QuestionResponse',
        JSON.stringify(videoDataObj)
      );
      console.log('Processing regular question with flag:', flag);

      // if (blob) {
      //   saveVideoFormData.append('Audio', blob);


        if (blob) {
          fileReader.readAsArrayBuffer(blob);
          fileReader.onloadend = async () => {
            const audioData = (await fileReader.result) as ArrayBuffer;
            await audioCtx.decodeAudioData(audioData, async (audioBuffer) => {
              const trimmedAudioBuffer = trimSilence(audioBuffer);
              const wavData = convertToWAV(trimmedAudioBuffer);
              audioBlob = new Blob([wavData], { type: 'audio/wav' });
              saveAudioFormData.append('Audio', audioBlob);
              // var blobURL = window.URL.createObjectURL(audioBlob);
              // var audio0 = new Audio(blobURL);
              // audio0.play();
              // console.log("audioBlob", audioBlob);
              isBlobGet = true;
              // saveAs(audioBlob, `Audio-${Date.now()}.wav`);

              const response: any = await saveEachQuestionAnswer(
                saveAudioFormData
              );
              // console.log('storeTimeStamp',storeTimeStamp)
              const storeDataFiltered = [
                ...storeTimeStamp
                  .reduce((map, obj) => map.set(obj.Q_number, obj), new Map())
                  .values(),
              ];
              if (response.status === 201 || response.status === 200) {
                isBlobGet = true;
                if (flag === true) {
                  await storeDataFiltered.map(
                    (allItems: any, index: number) => delete allItems.Q_number
                  );

                  // if (questionResponseTime) {
                  const responseTimeStamp = await storeTimeStampApi(
                    Array.from(new Map(
                      storeDataFiltered.map((item: any) => [
                        item['QuestionID'],
                        item,
                      ])
                    ).values())
                  );
                  setLastQuestionApiResponse(true);
                  if (
                    responseTimeStamp.status === 200 ||
                    responseTimeStamp.status === 201
                  ) {
                    setTimeout(async () => {
                      // setLastQuestionApiResponse(true);
                      // const EndInterview = await submitInterview(
                      //   interviewData?.candidate?.pk_CampaignLine_ID
                      // );
                    }, 50000);
                  }
                  await recorderForEachQuestionRecord?.startRecording();
                  SetRecorderForEachQuestionRecord(
                    recorderForEachQuestionRecord
                  );
                  // }
                }
              }
            });
          };
        }


      //       storeDataFiltered.forEach((item) => delete item.Q_number);

      //       await storeTimeStampApi([
      //         ...new Map(
      //           storeDataFiltered.map((item) => [item['QuestionID'], item])
      //         ).values(),
      //       ]);

      //       setLastQuestionApiResponse(true);
      //       SetRecorderForEachQuestionRecord(recorderForEachQuestionRecord);
      //     }
      //   }
      // }
      if (flag) {
        stopChunkUploader()
        const storeDataFiltered = [
          ...storeTimeStamp
            .reduce((map: any, obj: any) => map.set(obj.Q_number, obj), new Map())
            .values(),
        ];

        storeDataFiltered.forEach((item) => delete item.Q_number);

        console.log('storeDataFiltered', storeDataFiltered)
        await storeTimeStampApi(
          Array.from(new Map(
            storeDataFiltered.map((item: any) => [item['QuestionID'], item])
          ).values())
        );
        setLastQuestionApiResponse(true);
        SetRecorderForEachQuestionRecord(recorderForEachQuestionRecord);
      }

      await recorderForEachQuestionRecord.startRecording();
    }
  };

  // Function to initialize total questions count
  const initializeTotalQuestions = (questionsCount: number) => {
    console.log('Initializing total questions:', questionsCount);
    setTotalQuestions(questionsCount);
  };

  const changeQuestion = async (index: any): void => {
    setAudioPlay(questionsAudio[index]);

    setCurrentQuestion(questionsText[index].question_test);
    setCurrentQuestionIndex(index);
    setNoiseArray([]);
    setVideoArray(synthesiaVideoLinkArray[index]);
    storeEachQuestionsBlob(false);
    setIsLoadVideo(true);
  };

  const getAvtarImageFromInterviewVideo = async () => {
    let file;
    canvasRef.current
      ?.getContext('2d')
      ?.drawImage(
        myVideo.current,
        0,
        0,
        canvasRef.current?.width,
        canvasRef.current?.height
      );

    canvasRef.current?.toBlob(async (blob: any) => {
      file = new File([blob], 'test.png', { type: 'image/png' });
      setThumbnailImg(file);
    }, 'image/png');
  };

  function stopMediaTracks(stream: any) {
    stream?.getTracks().forEach((track: any) => {
      track.stop();
    });
  }
  function stopMediaVideoTracks() {
    activeStreams.forEach((streamItem) => {
      streamItem?.getTracks().forEach((track) => {
        track.stop();
      });
    });
  }

  function getAudioVideoConfigConstraints1(obj: any) {
    let currentAudioNew = null;
    let currentVideoNew = null;
    const videoConstraints: any = {};
    const audioConstraints: any = {};
    if (obj.kind === 'videoinput') {
      currentVideoNew = obj;
      videoConstraints.deviceId = { exact: currentVideoNew.deviceId };
      if (currentAudio) {
        audioConstraints.deviceId = { exact: currentAudio.deviceId };
      } else {
        audioConstraints.deviceId = 'environment';
      }
    }
    if (obj.kind === 'audioinput') {
      currentAudioNew = obj;
      audioConstraints.deviceId = { exact: currentAudioNew.deviceId };
      if (currentVideo) {
        videoConstraints.deviceId = { exact: currentVideo.deviceId };
      } else {
        videoConstraints.facingMode = 'user';
      }
    }
    if (obj === 'assigned') {
      if (currentVideo == null || currentVideo == undefined) {
        videoConstraints.facingMode = 'user';
      } else {
        videoConstraints.deviceId = { exact: currentVideo.deviceId };
      }

      if (currentAudio == null || currentAudio == undefined) {
        audioConstraints.deviceId = 'environment';
      } else {
        audioConstraints.deviceId = { exact: currentAudio.deviceId };
      }
    }

    return {
      video: videoConstraints,
      audio: audioConstraints,
    };
  }
  function getAudioVideoConfigConstraintsChange(obj: any) {
    let currentAudioNew = null;
    let currentVideoNew = null;
    const videoConstraints: any = {};
    const audioConstraints: any = {};

    const audioVideoData: any = JSON?.parse(
      localStorage.getItem('Video_Audio') || ''
    );

    if (obj.kind === 'videoinput') {
      currentVideoNew = obj;
      videoConstraints.deviceId = { exact: currentVideoNew.deviceId };
      audioConstraints.deviceId = { exact: audioVideoData?.audio?.deviceId };
    }

    if (obj === 'assigned') {
      if (currentVideo == null || currentVideo == undefined) {
        videoConstraints.facingMode = 'user';
      } else {
        videoConstraints.deviceId = { exact: currentVideo.deviceId };
      }
    }

    const constraints = {
      video: videoConstraints,
      audio: audioConstraints,
    };
    const audio_video_constraints = {
      audio: currentAudio,
      video: obj,
    };
    localStorage.setItem(
      'Video_Audio',
      JSON.stringify(audio_video_constraints)
    );
    return constraints;
  }

  function getAudioVideoConfigConstraints() {
    const videoConstraints: any = {};
    const audioConstraints: any = {};

    const audioVideoData: any =
      JSON?.parse(localStorage?.getItem('Video_Audio')) || '';

    if (audioVideoData.video === null || audioVideoData.video === undefined) {
      videoConstraints.facingMode = 'user';
    } else {
      videoConstraints.deviceId = { exact: audioVideoData.video.deviceId };
    }

    if (audioVideoData.audio == null) {
      audioConstraints.deviceId = 'environment';
    } else {
      audioConstraints.deviceId = { exact: audioVideoData.audio.deviceId };
    }

    return {
      video: videoConstraints,
      audio: audioConstraints,
    };
  }

  const onCameraAndAudioSettingSaveChange = (obj: any) => {
    let constraints = getAudioVideoConfigConstraintsChange(obj);

    navigator.mediaDevices
      .getUserMedia(constraints)
      .then((stream) => {
        setStream(stream);
        setActiveStreams((prev) => [...prev, stream]);
        setVideoBlob(undefined);
        myVideo.current.srcObject = stream;
        return navigator.mediaDevices.enumerateDevices();
      })
      .then((devices) => {
        setAudioDevices([]);
        setVideoDevices([]);
        devices.forEach((device) => {
          if (device.kind == 'audioinput' && device.label)
            setAudioDevices((prev: any) => [...prev, device]);

          if (device.kind == 'videoinput' && device.label)
            setVideoDevices((prev: any) => [...prev, device]);
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const onCameraAndAudioSettingSave = (obj: any) => {
    if (stream === null || stream === undefined) {
    } else {
      stopMediaTracks(stream);
    }
    let constraints = getAudioVideoConfigConstraints1(obj);
    navigator.mediaDevices
      .getUserMedia(constraints)
      .then((stream) => {
        setStream(stream);
        setActiveStreams((prev) => [...prev, stream]);
        setVideoBlob(undefined);
        myVideo.current.srcObject = stream;
        return navigator.mediaDevices.enumerateDevices();
      })
      .then((devices) => {
        setAudioDevices([]);
        setVideoDevices([]);
        devices.forEach((device) => {
          if (device.kind == 'audioinput' && device.label)
            setAudioDevices((prev: any) => [...prev, device]);

          if (device.kind == 'videoinput' && device.label)
            setVideoDevices((prev: any) => [...prev, device]);
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  let clockRef = useRef<any>();

  const startInterviewTimer = () => {
    const clock: any = document.getElementById('time');
    let time = -1;

    function incrementTime() {
      time++;
      clock.textContent =
        ('0' + Math.trunc(time / 3600)).slice(-2) +
        ' : ' +
        ('0' + Math.trunc(time / 60)).slice(-2) +
        ' : ' +
        ('0' + (time % 60)).slice(-2);
    }

    incrementTime();
    setTotalInterviewTime({
      ...totalInterviewTime,
      startTime: new Date(),
    });

    intervalId = setInterval(incrementTime, 1000);
  };

  const stopInterviewTimer = () => {
    const clock: any = document.getElementById('time');

    // clock.textContent = '00:00:00'
    setTotalInterviewTime({ ...totalInterviewTime, endTime: new Date() });

    clearInterval(intervalId);
    intervalId = null;
  };

  const startRecordingVideo = async () => {

    if (!!stream) {
      setTimeout(() => {
        getAvtarImageFromInterviewVideo();
      }, 10000);
    }

    startChunkUploader()

    setAudioPlay(questionsAudio[0]);
    setVideoArray(synthesiaVideoLinkArray[0]);
    setCurrentQuestion(questionsText[0]?.question_test);
    setCurrentQuestionIndex(0);
    if (typeof stream?.getTracks == 'function') {
      stopMediaTracks(stream);
      setStream(null);
    }

    try {
      let constraints1: any = getAudioVideoConfigConstraints();

      const streamL = await navigator.mediaDevices.getUserMedia(constraints1);
      let audioTrack = streamL.getAudioTracks()[0];
      streamL?.addTrack(audioTrack);
      const canvasStream = canvasOutputRef.current?.captureStream();
      canvasStream?.addTrack(audioTrack);
      const recorder = new RecordRTCPromisesHandler(
        canvasStream,
        {
          type: 'video',
          frameRate: 15,
          disableLogs: true,
          mimeType: 'video/webm',
          videoBitsPerSecond: 500000,
        }
      );

      const recorderForEachQuestionRecord = new RecordRTCPromisesHandler(
        streamL,
        {
          type: 'video',
          frameRate: 15,
          disableLogs: true,
          mimeType: 'video/webm',
          videoBitsPerSecond: 500000,
        }
      );

      setIsRecordingStarted(true);

      await recorder?.startRecording();



      setRecorder(recorder);
      SetRecorderForEachQuestionRecord(recorderForEachQuestionRecord);
      setStream(streamL);
      setActiveStreams((prev) => [...prev, streamL]);
      setFinalStream(finalStream);

      setVideoBlob(undefined);
      myVideo.current.srcObject = streamL;

      setIsInitState(false);
    } catch (err) {
      console.error(err);
    }
  };

  const saveSplitedVideo = async () => {
    if (questionsText?.length - 1 !== currentQuestionIndex) {
      await recorder?.stopRecording();
      let blob = await recorder?.getBlob();

      const tempBlob = [...blobInterval];
      tempBlob.push(blob);
      var blobURL = window.URL.createObjectURL(blob);
      var videoElement = document.createElement('video');
      videoElement.src = blobURL;
      setBlobInterval(tempBlob);
      await recorder?.startRecording();
      setRecorder(recorder);
      setStream(stream);
      if (stream) {
        setActiveStreams((prev) => [...prev, stream]);
      }

      myVideo.current.srcObject = stream;
    }
  };

  function convertToWAV(audioBuffer: AudioBuffer) {
    const channelData = audioBuffer.getChannelData(0);
    const buffer = new ArrayBuffer(44 + channelData.length * 2);
    const view = new DataView(buffer);

    writeString(view, 0, 'RIFF');
    view.setUint32(4, 32 + channelData.length * 2, true);
    writeString(view, 8, 'WAVE');
    writeString(view, 12, 'fmt ');
    view.setUint32(16, 16, true);
    view.setUint16(20, 1, true);
    view.setUint16(22, 1, true);
    view.setUint32(24, audioBuffer.sampleRate, true);
    view.setUint32(28, audioBuffer.sampleRate * 2, true);
    view.setUint16(32, 2, true);
    view.setUint16(34, 16, true);
    writeString(view, 36, 'data');
    view.setUint32(40, channelData.length * 2, true);

    /* Write PCM data */
    const floatTo16BitPCM = (
      output: DataView,
      offset: number,
      input: Float32Array
    ) => {
      for (let i = 0; i < input.length; i++, offset += 2) {
        const s = Math.max(-1, Math.min(1, input[i]));
        output.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true);
      }
    };
    floatTo16BitPCM(view, 44, channelData);

    return buffer;
  }

  function writeString(view: DataView, offset: number, string: string): void {
    for (let i = 0; i < string.length; i++) {
      view.setUint8(offset + i, string.charCodeAt(i));
    }
  }

  const stopRecording = async () => {
    console.log('recorderForEachQuestionRecord------------------->', recorderForEachQuestionRecord)
    if (recorderForEachQuestionRecord) {
      storeEachQuestionsBlob(true);
    }

    if (recorder) {
      setTimeout(async () => {
        await recorder.stopRecording();
        recorderForEachQuestionRecord?.stopRecording();

        let blob: Blob = await recorder.getBlob();

        stream?.getTracks().forEach((track: any) => {
          track.stop();
          track.enabled = false;
        });
        finalStream?.getTracks().forEach((track: any) => {
          track.stop();
          track.enabled = false;
        });
        stopMediaVideoTracks();

        myVideo.current.srcObject = null;

        canvasOutputRef.current = null;
        setVideoBlob(blob);
        stopInterviewTimer();

        downloadVideo(blob);

      }, 3000);
    }
  };

  const submitData = async () => {

    if (videoBlob) {
      const saveVideoFormData = new FormData();
      const saveAudioFormData = new FormData();

      saveVideoFormData.append('', videoBlob);

      let audioBlob: Blob | null = null;
      const audioCtx = new AudioContext();
      const fileReader: any = new FileReader();
      fileReader.readAsArrayBuffer(videoBlob);
      fileReader.onloadend = () => {
        const audioData = fileReader.result as ArrayBuffer;
        audioCtx.decodeAudioData(audioData, (audioBuffer) => {
          const wavData = convertToWAV(audioBuffer);
          audioBlob = new Blob([wavData], { type: 'audio/wav' });
          saveAudioFormData.append('', audioBlob);
        });
      };

      const [hours, minutes, seconds] = timeState.split(':').map(Number);
      const totalSeconds = hours * 3600 + minutes * 60 + seconds;

      await (async () => {
        const tempData = { ...interviewData.candidate };
        const candidate_link = sessionStorage.getItem('candidate_link') || '';

        const date = new Date(Date.now());
        const InterviewDataSpeech = {
          fk_Enterprise_ID: tempData.fk_Enterprise_ID,
          fk_EnterpriseCostCentre_ID: 5,
          fk_User_ID: tempData.fk_User_ID,
          fk_Campaign_ID: tempData.fk_Campaign_ID,
          fk_CampaignLine_ID: tempData.pk_CampaignLine_ID,
          CampaignLine_CandidateLink: candidate_link,
          InterviewDataSpeech_Score: '',
          InterviewDataSpeech_Optional_1: '',
          InterviewDataSpeech_Optional_2: '',
          InterviewDataSpeech_Optional_3: '',
          InterviewDataSpeech_Optional_4: '',
          InterviewDataSpeech_Optional_5: '',
          InterviewDataSpeech_DataString: '',
          InterviewDataSpeech_Deleted: 0,
          InterviewDataSpeech_Status: 1,
          InterviewDataSpeech_AccessLevel: 1,
          InterviewDataSpeech_AudioUrl: '',
          InterviewDataSpeech_TimeStamp: date.toUTCString(),
        };

        saveAudioFormData.append(
          'InterviewDataSpeech',
          JSON.stringify(InterviewDataSpeech)
        );

        const data = {
          fk_Enterprise_ID: tempData.fk_Enterprise_ID,
          fk_EnterpriseCostCentre_ID: 5,
          fk_User_ID: tempData.fk_User_ID,
          fk_Campaign_ID: tempData.fk_Campaign_ID,
          fk_CampaignLine_ID: tempData.pk_CampaignLine_ID,
          InterviewVideo_CandidateLink: '',
          InterviewVideo_TimeStamp: totalSeconds.toString(),
          InterviewVideo_DataString: '',
          InterviewVideo_Deleted: 0,
          InterviewVideo_Status: 0,
          InterviewVideo_AccessLevel: 1,
        };

        const response: any = await createInterviewVideoBlob(data);

        if (thumbnailImg) {
          const saveThumbnail = new FormData();
          saveThumbnail.append('', thumbnailImg);

          await axios
            .post(
              `${BASE_URL}/InterviewVideo/SaveVideoThumbnail?pk_CampaignLine_ID=${interviewData?.candidate?.pk_CampaignLine_ID}`,
              saveThumbnail,
              {
                headers: {
                  'Content-Type': 'application/octet-stream',
                  Authorization: `Bearer ${localStorage.getItem('token') || ''
                    }`,
                },
              }
            )
            .then((response) => { })
            .catch((err) => {
              console.log(err);
            });
        }

        if (response.status === 201) {

          const accessToken = localStorage.getItem('token') || '';

          const headers = {
            'Content-Type': 'application/octet-stream',
            Authorization: `Bearer ${accessToken}`,
          };

          const postResult = await axios.post(
            `${BASE_URL}/InterviewVideo/SaveVideo?pk_CampaignLine_ID=${tempData?.pk_CampaignLine_ID}`,
            saveVideoFormData,
            {
              headers: headers,
              // onUploadProgress: (data: any) => {
              //   setUploadProgress(
              //     // Math.round(((100 * data.loaded) / data.total) * 30) / 100|
              //     Math.round(((100 * data.loaded) / data.total) * 90) / 100
              //   );
              // },
              onUploadProgress: (data: any) => {
                setUploadProgress((prev) => {
                  let uploadProgressNumber =
                    Math.round(((100 * data.loaded) / data.total) * 90) / 100;

                  return uploadProgressNumber > prev
                    ? uploadProgressNumber
                    : prev;
                });
              },
            }
          );

          // const postResultOfAudioUpload = await axios.post(
          //   `${BASE_URL}/InterviewDataSpeech/SaveAudio`,
          //   saveAudioFormData,
          //   {
          //     headers: headers,
          //     onUploadProgress: (data: any) => {
          //       setUploadProgress((prev) => {
          //         let uploadProgressNumber =
          //           Math.round(((100 * data.loaded) / data.total) * 90) / 100;

          //         return uploadProgressNumber > prev
          //           ? uploadProgressNumber
          //           : prev;
          //       });
          //     },
          //   }
          // );

          if (
            postResult.status === 200
            //  &&
            // (postResultOfAudioUpload.status === 200 ||
            //   postResultOfAudioUpload.status === 201)
          ) {
            setInterviewAudioResponse(true);
            // sendNotification({ msg: 'Interview Uploaded Successfully' });
          } else {
            setUploadProgress(0);
            // sendNotification({
            //   msg: 'Interview Uploading Failed!',
            //   variant: 'error',
            // });
          }

        }
      })();
      localStorage.removeItem('step_active');
      localStorage.removeItem('Video_Audio');
    }
  };

  useEffect(() => {
    if (interviewStatus.isInterviewFinished) {
      submitData();
    }
  }, [interviewStatus.isInterviewFinished, isSynthesiaClosingPlaying]);

  const downloadVideo = (blob: any) => {
    new File([blob], 'demo.mp4', { type: 'video/mp4' });
  };

  const onAudioDataHandler = (data: { size: number }) => {
    if (data.size > 1100) {
      setNoiseArray((prevState: any[]) => [...prevState, data.size]);
    }
  };

  const onToggleScreen = () => {
    setShowSelfScreen((prevState: any) => !prevState);
  };

  const [totalTimeOfInterview, setTotalTimeOfInterview] =
    useState('00 : 00 : 00');

  return (
    <MainContext.Provider
      value={{
        myVideo,
        finalVideo,
        stream,
        showSelfScreen,
        isRecordingStarted,
        setIsRecordingStarted,
        speaking,
        recorder,
        setRecorder,
        interviewStatus,
        setInterviewStatus,
        uploadProgress,
        isLoading,
        setIsLoading,
        isCameraAndMicSettingOpen,
        setIsCameraAndMicSettingOpen,
        canvasOutputRef,
        startRecordingVideo,
        stopRecording,
        changeQuestion,
        videoBlob,
        currentQuestionIndex,
        questionsText,
        startInterviewTimer,
        currentQuestion,
        onToggleScreen,
        extendedSilence,
        audioPlay,
        isSplitVideo,
        saveSplitedVideo,
        setQuestionsText,
        setQuestionsAudio,
        interviewData,
        setInterviewData,
        isTimerOn,
        setIsTimerOn,
        audioDevices,
        currentAudio,
        currentVideo,
        setCurrentAudio,
        setCurrentVideo,
        setIsSplitVideo,
        setExtendedSilence,
        onCameraAndAudioSettingSave,
        noiseArray,
        isInitState,
        setStream,
        setVideoBlob,
        setOpenPermissionDialog,
        setAudioDevices,
        videoDevices,
        setVideoDevices,
        canvasCtx,
        videoBackgroundConfig,
        setFinalStream,
        setExtendedSilenceArray,
        setVideoBackgroundConfig,
        openPermissionDialog,
        convertToWAV,
        isVideoBackgroundEnabled,
        setIsVideoBackgroundEnabled,
        setTotalInterviewTime,
        clockRef,
        isQuestionSpeaking,
        setIsQuestionSpeaking,
        totalTimeOfInterview,
        setTotalTimeOfInterview,
        onAudioDataHandler,
        canvasRef,
        jobData,
        setJobData,
        recruiterName,
        setRecruiterName,
        interviewUploadSuccessfull,
        setInterviewUploadSuccessfull,
        tempCurrentVideo,
        setTempCurrentVideo,
        tempCurrentAudio,
        setTempCurrentAudio,
        stopMediaTracks,
        getAudioVideoConfigConstraints,
        storeTimeStamp,
        setStoreTimeStamp,
        recorderForEachQuestionRecord,
        SetRecorderForEachQuestionRecord,
        logoutState,
        setNoiseArray,
        timerOff,
        setTimerOff,
        speak,
        speakingScreen,
        setSpeakingScreen,
        setIsInitState,
        timer,
        setTimer,
        setCurrentQuestionIndex,
        setOnboardingCandidateData,
        // setOnboardingCampaignData,
        onboardingCandidateData,
        setCandidateLinkId,
        candidateLinkId,
        candidateData,
        setCandidateData,
        onCameraAndAudioSettingSaveChange,
        timeState,
        setTimeState,
        setEnterpriseData,
        enterpriseData,
        questionVideoRef,
        videoArray,
        isQuestionVideoPlay,
        isLoadVideo,
        setIsLoadVideo,
        synthesiaVideoLinkArray,
        setSynthesiaVideoLinkArray,
        synthesiaVideos,
        setSynthesiaVideos,
        closingVideoPlay,
        initialVideoPlay,
        setClosingVideoPlay,
        setInitialVideoPlay,
        openPopup,
        setOpenPopup,
        isSynthesiaClosingPlaying,
        setIsSynthesiaClosingPlaying,
        // Interview completion tracking
        totalQuestions,
        setTotalQuestions,
        isLastQuestion,
        setIsLastQuestion,
        isFinishButtonPressed,
        setIsFinishButtonPressed,
        shouldExecuteFinalFlow,
        setShouldExecuteFinalFlow,
        initializeTotalQuestions,
        executeFinalQuestionFlow,
      }}
    >
      {children}
    </MainContext.Provider>
  );
};

const useInterviewContext = () => {
  return useContext(MainContext);
};

export default useInterviewContext;
